// extracted by mini-css-extract-plugin
export default {"group":"_wvDO","groupName":"Cid59","category":"crtVH","categories":"Hq5XL"};